import { useContext } from "react";
import { ParagraphText } from "../../../Libraries";
import { Grid } from "@mui/material";
import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./styles.module.css";

const AppCustomerSiderbarDetail = ({
  custInfoData,
}) => {
  const [I18n] = useContext(LanguageContext);

  return (
    <div className={styles.wrapper}>      
      <Grid container className={styles.infoGridContainer}>
        {(custInfoData || []).map((cinfo, ind) =>
          cinfo?.value ? (
            <Grid item md={6} className={`${styles.infoItem} ${cinfo.className}`} key={ind}>
              <ParagraphText className={styles.infoTitle} title={cinfo.title}>
                {cinfo.title}
              </ParagraphText>
              <ParagraphText
                className={`${styles.infoValue} ${cinfo.title === I18n.notes ? styles.notesBox : cinfo.className || ""}`}
                title={cinfo.value}
              >
                {cinfo.value}
              </ParagraphText>
            </Grid>
          ) : null,
        )}
      </Grid>
    </div>
  );
};

export default AppCustomerSiderbarDetail;
